import React from 'react';
import { Button, Stack } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';

interface ContactButtonsProps {
  phoneNumber?: string;
  emailAddress?: string;
  locationsUrl?: string;
}

const ContactButtons: React.FC<ContactButtonsProps> = ({
  phoneNumber = '+263-242-792822',
  emailAddress = 'enquiries@smedco.co.zw',
  locationsUrl = '/locations'
}) => {
  const handlePhoneClick = () => {
    // For mobile devices, try to open phone dialer
    if (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      window.open(`tel:${phoneNumber}`, '_self');
    } else {
      // For desktop, copy phone number to clipboard
      navigator.clipboard.writeText(phoneNumber).then(() => {
        alert(`Phone number copied to clipboard: ${phoneNumber}`);
      }).catch(() => {
        alert(`Phone: ${phoneNumber}`);
      });
    }
  };

  const handleEmailClick = () => {
    // Open email client
    window.open(`mailto:${emailAddress}?subject=SMEDCO Support Request&body=Hello, I need assistance with...`, '_self');
  };

  const handleLocationClick = () => {
    // Navigate to locations page
    window.location.href = locationsUrl;
  };

  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 2 }}>
      <Button
        variant="contained"
        color="primary"
        startIcon={<PhoneIcon />}
        fullWidth
        onClick={handlePhoneClick}
      >
        Call Now
      </Button>
      <Button
        variant="contained"
        color="secondary"
        startIcon={<EmailIcon />}
        fullWidth
        onClick={handleEmailClick}
      >
        Leave Email
      </Button>
      <Button
        variant="contained"
        color="info"
        startIcon={<LocationOnIcon />}
        fullWidth
        onClick={handleLocationClick}
      >
        Find Locations
      </Button>
    </Stack>
  );
};

export default ContactButtons; 